module.exports = __webpack_public_path__ + "assets/images/10HB.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/10HB.png
// module id = 1280
// module chunks = 1